module.exports = "<div class=\"center\">\n  <my-button my-label=\"$root.labels.wagon.statements.toggleMovements(displayMovements)\"\n    my-icon=\"$root.icons.display(displayMovements)\"\n    my-style=\"$root.styles.dark(displayMovements)\"\n    my-click=\"toggleDisplay()\">\n  </my-button>\n\n  <my-data-display my-data=\"movements\"\n    enable-excel=\"true\"\n    my-nature=\"'movement'\"\n    ng-show=\"displayMovements\">\n  </my-data-display>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayMovements.html
// module id = 1103
// module chunks = 0